
<!--
    描述：菜单列表
    日期：2021/06/07
    作者：zwh
-->
<template>
    <div class="h100">
        <div class="w-page-main">
            <div class="w-page-header superiors-search-area">
                <div class="left-text overflow-hidden">
                    <span><b>管理菜单列表</b></span>
                </div>
                <div class="btnGroups">
                    <el-button v-if="roleBtns.includes('limit_menu_range_save')"
                               type="success"
                               size="small"
                               icon="el-icon-check"
                               :loading="btnLoading"
                               @click="saveClick()">保存
                    </el-button>
                </div>
            </div>

            <div class="w-page-container pdb10">
                <div class="w-table-layout">
                    <div class="w-table-content"
                         ref="content"
                         style=" overflow-y: auto; border:1px solid #eee">
                        <el-tree ref="menusTree"
                                 :height="treeObj.tableH"
                                 :data="treeObj.data"
                                 :props="defaultProps"
                                 :expand-on-click-node="false"
                                 :highlight-current="true"
                                 default-expand-all
                                 show-checkbox
                                 :check-strictly="true"
                                 node-key="id"
                                 :default-checked-keys="treeDefaultCheckedKey"
                        ></el-tree>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from "vuex";
    import { saveOrUpdateLimitMenuRange } from 'api/system/sysLimitMenuRange.js'
    export default {
        name : '',
        props: {
            // 主体id
            limitId: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                btnLoading: false,
                treeDefaultCheckedKey: [],
                treeObj: {
                    loading: false,
                    tableH: 200,
                    data: [],
                    treeOriData: [],
                    treeByRoleData: []
                },
                defaultProps: {
                    children: 'children',
                    label: 'sname'
                },
            }
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.treeObj.tableH = this.$refs.content.offsetHeight;
                }, 100)
            })
        },
        methods: {
            // 保存
            saveClick(){
                let that = this
                that.btnLoading = true
                if (that.limitId == '') {
                    that.$message({message: '请选择主体信息', type: 'warning'});
                    return;
                }

                let checkSelection = this.$refs.menusTree.getCheckedKeys().concat()
                let param = {
                    limitId: that.limitId,
                    isSys: '0',   // 系统菜单
                    menuIdsSelection: checkSelection
                }
                saveOrUpdateLimitMenuRange(param)
                    .then(res => {
                        that.btnLoading = false
                        if (res.operationCode == 1) {
                            that.$message({message: '保存成功', type: 'success'});
                        }else {
                            that.$message({message: '保存失败！', type: 'error'});
                        }
                    })
                    .catch(err => {
                        that.btnLoading = false
                    })
            },

            // 更新选中状态
            updateTree(arr) {
                this.$refs.menusTree.setCheckedKeys(arr, true)
            }
        },
        computed: {
            ...mapState('app', { clientSize: state => state.clientSize }),
            ...mapState('menu', {
                roleBtns: state => state.roleBtns
            })
        },
        watch: {
            clientSize(val) {
                this.treeObj.tableH = this.$refs.content.offsetHeight - 45
            }
        },
    }
</script>
<style lang="less">

</style>